import {
  useState,
  useEffect,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from "react";
import { Col, Row, Form, Input, Modal, InputRef, message } from "antd";
import "./style.css";
import Title from "../../../UI/Title/Title";
import { useTranslation } from "react-i18next";
import Calculator from "../../../UI/Calculator/calculator";
import ConfirmModall from "./confirmModal";
import { useSelector } from "react-redux";
import {
  ChangeStateContext,
  exchangeRateContext,
  returnedContext,
  tenderedLBPContext,
} from "../../MainFour";
import { getIsPrintReceipt } from "../../../../utils/main-utils";

type payprops = {
  isPayOpen: boolean;
  setIsPayOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handlePay: (changeLBP: string, changeUSD: string) => void;
  currency: any;
  isPaid: boolean;
  setIsPaid: React.Dispatch<React.SetStateAction<boolean>>;
};

const Pay = ({
  isPayOpen,
  setIsPayOpen,
  handlePay,
  currency,
  setIsPaid,
}: payprops) => {
  const { exchangeRate } = useContext(exchangeRateContext);
  const {
    returnedLBP,
    returnedUSD,
    setReturnedUSD,
    setReturnedLBP,
    overpaymentUSD,
    setOverpaymentUSD,
  } = useContext(returnedContext);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [inputInFocus, setInputInFocus] = useState<
    "usd" | "lbp" | "rUsd" | "rLbp"
  >("usd");
  const [changeUSD, setChangeUSD] = useState<number>(0);
  const [changeLBP, setChangeLBP] = useState<number>(0);
  const [form] = Form.useForm();
  const [t] = useTranslation("common");
  const { tenderedUSD, setTenderedUSD } = useContext(ChangeStateContext);
  const discount = useSelector((state: any) => state.main.discount);
  const finalPrice = useSelector((state: any) => state.main.finalPrice);
  const totalPrice = useSelector((state: any) => state.main.totalPrice);

  const ReduxDeliveryCharge = useSelector((state: any) => state.main.deliveryCharge)
  const ReduxDeliveryLocation = useSelector((state: any) => state.main.deliveryLocation)
  const ReduxDeliveryChargeText = useSelector((state: any) => state.main.deliveryChargeText)

  const tenderedAmountUSDRef = useRef<InputRef>(null);
  const { tenderedLBP, setTenderedLBP } = useContext(tenderedLBPContext);

  const setAmount = (
    setState: Dispatch<SetStateAction<string | number>>,
    state: number | string,
    value: any
  ) => {
    if (value === "C") {
      setState("");
    } else if (value === "backspace") {
      setState(String(state)?.slice(0, -1));
    } else if (value === ".") {
      const numericValue = /^\d+(\.\d*)?$/.test(state + ".")
        ? state + "."
        : state;
      setState(numericValue);
    } else {
      const numericValue = /^\d+(\.\d*)?$/.test(state + value.toString())
        ? state + value.toString()
        : state;
      setState(numericValue);
    }
  };
  const handleButtonClick = (value: any) => {
    if (inputInFocus === "usd") {
      setAmount(setTenderedUSD, tenderedUSD, value);
    } else if (inputInFocus === "lbp") {
      setAmount(setTenderedLBP, tenderedLBP, value);
    } else if (inputInFocus === "rLbp") {
      setAmount(setReturnedLBP, returnedLBP, value);
    } else {
      setAmount(setReturnedUSD, returnedUSD, value);
    }
  };

  useEffect(() => {
    const totalUSD = finalPrice;
    const totalLBP = finalPrice * exchangeRate;

    form.setFieldValue("amount", tenderedUSD);
    form.setFieldValue("amountLBP", tenderedLBP);
    form.setFieldValue("returnedUSD", overpaymentUSD);
    form.setFieldValue("returnedLBP", returnedLBP);

    // Calculate change amounts
    const calculatedChangeUSD =
      Number(tenderedUSD) -
      totalUSD +
      Number(tenderedLBP) / exchangeRate -
      (Number(returnedLBP) / exchangeRate + Number(returnedUSD));

    const calculatedChangeLBP =
      Number(tenderedUSD) * exchangeRate -
      totalLBP +
      Number(tenderedLBP) -
      (Number(returnedLBP) + Number(returnedUSD) * exchangeRate);

    // Ensure change amounts are positive or zero
    const finalChangeUSD = Math.abs(
      calculatedChangeUSD < 0 ? calculatedChangeUSD : 0
    );
    const finalChangeLBP = Math.abs(
      calculatedChangeLBP < 0 ? calculatedChangeLBP : 0
    );
    // Calculate overpayment amounts if paid more than the total
    const overpaymentUSDAmount =
      calculatedChangeUSD < 0 ? 0 : calculatedChangeUSD;
    // Update the state with the calculated change amounts
    setChangeUSD(finalChangeUSD);
    setChangeLBP(finalChangeLBP);
    setOverpaymentUSD(overpaymentUSDAmount);
    form.setFieldValue("returnedUSD", overpaymentUSDAmount);
  }, [
    exchangeRate,
    finalPrice,
    form,
    tenderedUSD,
    tenderedLBP,
    returnedLBP,
    overpaymentUSD,
    returnedUSD,
    setOverpaymentUSD,
  ]);

  useEffect(() => {
    const totalUSD = finalPrice;
    const totalLBP = finalPrice * exchangeRate;

    const amountObj = JSON.stringify({
      fp: parseFloat(totalUSD) || 0,
      ut: parseFloat(tenderedUSD) || 0,
      lt: parseFloat(tenderedLBP) || 0,
    });
    localStorage.setItem("amount", amountObj);

    form.setFieldValue("amount", tenderedUSD);
    form.setFieldValue("amountLBP", tenderedLBP);
    form.setFieldValue("returnedUSD", overpaymentUSD);
    form.setFieldValue("returnedLBP", returnedLBP);

    // Calculate change amounts
    const calculatedChangeUSD =
      Number(tenderedUSD) -
      totalUSD +
      Number(tenderedLBP) / exchangeRate -
      (Number(returnedLBP) / exchangeRate + Number(returnedUSD));

    const calculatedChangeLBP =
      Number(tenderedUSD) * exchangeRate -
      totalLBP +
      Number(tenderedLBP) -
      (Number(returnedLBP) + Number(returnedUSD) * exchangeRate);

    // Ensure change amounts are positive or zero
    const finalChangeUSD = Math.abs(
      calculatedChangeUSD < 0 ? calculatedChangeUSD : 0
    );
    const finalChangeLBP = Math.abs(
      calculatedChangeLBP < 0 ? calculatedChangeLBP : 0
    );
    // Calculate overpayment amounts if paid more than the total
    const overpaymentUSDAmount =
      calculatedChangeUSD < 0 ? 0 : calculatedChangeUSD;
    // Update the state with the calculated change amounts
    setChangeUSD(finalChangeUSD);
    setChangeLBP(finalChangeLBP);
    setOverpaymentUSD(overpaymentUSDAmount);
    form.setFieldValue("returnedUSD", overpaymentUSDAmount);
  }, [
    exchangeRate,
    finalPrice,
    form,
    tenderedUSD,
    tenderedLBP,
    returnedLBP,
    overpaymentUSD,
    returnedUSD,
    setOverpaymentUSD,
  ]);
  function numberWithCommas(x: number) {
    return x && x?.toFixed(2)?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
  function numberWithCommasLBP(x: number) {
    return x && x?.toFixed(0)?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  useEffect(() => {
    setTimeout(() => {
      isPayOpen && tenderedAmountUSDRef.current?.focus();
    }, 0);
  }, [isPayOpen]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    // const numericValue = /^\d+(\.\d*)?$/.test(inputValue) ? inputValue : "";

    return inputValue;
  };
  const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    // e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  };

  const handlePayment = async () => {
    // Convert input values to numbers
    const tenderedUSDValue = parseFloat(tenderedUSD);
    const tenderedLBPValue = parseFloat(tenderedLBP);
    const finalPriceValue = parseFloat(finalPrice);

    // Check if the entered amount is empty
    if (
      (!tenderedUSDValue || isNaN(tenderedUSDValue)) &&
      (!tenderedLBPValue || isNaN(tenderedLBPValue))
    ) {
      // Show an error message indicating that the amount is empty
      message.error("Invalid amount");
      return; // Stop further processing
    }
    let totalAmount;
    if (inputInFocus === "usd") {
      totalAmount = tenderedUSDValue;
    } else if (inputInFocus === "lbp") {
      totalAmount = tenderedLBPValue;
    }
    const isFullyPaid = tenderedUSDValue >= finalPriceValue;
    try {
      setIsOpenConfirm(true);
      setIsPaid(isFullyPaid);
    } catch (error: any) {
      message.error(error.response.data.message);
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Check if the entered value is negative
    if (parseFloat(inputValue) < 0) {
      // Display an error message
      message.error("Amount cannot be negative.");
      // Return the current state to prevent the change
      return tenderedUSD;
    }

    // If the value is not negative, update the state
    return inputValue;
  };
  const handleKeyPress = (event: any) => {
    const isValidKey = /^\d$/.test(event.key) || event.key === ".";

    if (!isValidKey) {
      event.preventDefault();
    }
  };

  return (
    <>
      <Modal
        maskClosable={false}
        closable={false}
        width={1000}
        centered
        open={isPayOpen}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          htmlType: "submit",
          form: "pay",
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        cancelText={t('cancel')}
        okText={`${getIsPrintReceipt() ? t("print") : t('save')}`}
        onCancel={() => {
          setIsPayOpen(false);
          setTenderedUSD(finalPrice);
          setTenderedLBP("");
          setReturnedUSD("");
          setReturnedLBP("");
        }}
        onOk={() => {
          handlePayment();
          document.body.classList.remove("body-scroll-lock");
        }}
      >
        <Form id="pay" layout="vertical" form={form}>
          <Col offset={1} span={23}>
            <Title title={`${t("pay-with-cash")}`} />
          </Col>
          <br />
          <Row>
            <Col offset={1} span={5}>
              <Form.Item
                // name="amount"
                label={`${t("amount-tendered")} USD`}
                id="amount"
              >
                <Input
                  type="number"
                  min={"1"}
                  onFocus={() => setInputInFocus("usd")}
                  ref={tenderedAmountUSDRef}
                  autoComplete="off"
                  placeholder={`${t("enter-text")}`}
                  value={Number(tenderedUSD)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setTenderedUSD(handleInput(e));
                  }}
                  onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                    onInput(e);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </Form.Item>
              <Form.Item
                name="amountLBP"
                label={`${t("amount-tendered")} LBP`}
                id="amount"
              >
                <Input
                  onFocus={() => {
                    setInputInFocus("lbp");
                  }}
                  min={"1"}
                  autoComplete="off"
                  placeholder={`${t("enter-text")}`}
                  value={Number(tenderedLBP)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setTenderedLBP(handleInput(e));
                  }}
                  onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                    onInput(e);
                  }}
                  onKeyPress={(
                    event: React.KeyboardEvent<HTMLInputElement>
                  ) => {
                    // Get the current input value
                    const inputValue = event.currentTarget.value;

                    // Check if the key pressed is a period and if there is already a period in the input value
                    if (event.key === "." && inputValue.includes(".")) {
                      event.preventDefault(); // Prevent adding another period
                    }

                    // Allow only digits and one period
                    const isValidKey =
                      /^\d$/.test(event.key) ||
                      (event.key === "." && !inputValue.includes("."));

                    if (!isValidKey) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>

              <Row style={{ margin: "10px 0" }}>
                <Col span={24}>{t('remaining')} USD: {changeUSD.toFixed(2)}</Col>
                <Col span={24}>
                  {t('remaining')} LBP: {numberWithCommasLBP(changeLBP)}
                </Col>
              </Row>

              <Form.Item name="returnedUSD" label={`${t("change")} USD`}>
                <Input
                  style={{ color: "grey" }}
                  autoComplete="off"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setReturnedUSD(handleInputChange(e));
                  }}
                  placeholder="Change USD"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col offset={1} span={8}>
              <Calculator handleButtonClick={handleButtonClick} />
            </Col>

            <Col
              offset={1}
              span={8}
              style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                gap: "20px",
              }}
            >
              <Row>
                <Col span={12} className="titlestyle">
                  {" "}
                  {t("exchange-rate")}:
                </Col>
                <Col span={8} className="number-color">
                  {numberWithCommasLBP(exchangeRate || 1)}
                </Col>
              </Row>

              {/*-----------balance-------------- */}
              <Row>
                <Col span={12} className="titlestyle">
                  {t("balance-due")}:
                </Col>
                <Col span={8} className="number-color">
                  {numberWithCommas(totalPrice)} {currency?.abbreviation}
                </Col>
              </Row>

              {/*-----------Delivery-------------- */}
              <Row>
                <Col span={12} className="titlestyle">
                  {" "}
                  {t("delivery")}:
                </Col>
                <Col span={8} className="number-color">
                  {numberWithCommas(ReduxDeliveryCharge) ?? "0.00"} USD
                </Col>
              </Row>

              {/*-----------discount-------------- */}
              <Row>
                <Col span={12} className="titlestyle">
                  {" "}
                  {t("discount")}:
                </Col>
                <Col span={8} className="number-color">
                  {discount?.amount?.toFixed(2)} {" "}
                  {discount.type === "#"
                    ? currency?.abbreviation
                    : discount?.type}
                </Col>
              </Row>

              {/*-----------total-------------- */}
              <Row>
                <Col span={12} className="titlestyle">
                  {" "}
                  {t("total")} USD:
                </Col>
                <Col span={8} className="number-color">
                  {numberWithCommas(Number(finalPrice))} {" "}
                  {currency?.abbreviation}
                </Col>
              </Row>
              <Row>
                <Col span={12} className="titlestyle">
                  {" "}
                  {t("total")} LBP:
                </Col>
                <Col span={8} className="number-color">
                  {numberWithCommasLBP(Number(finalPrice * exchangeRate))}
                  {" LBP"}
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/*------------------MODALS-----------*/}

      <ConfirmModall
        handlePay={() => handlePay(returnedLBP, returnedUSD)}
        isOpenConfirm={isOpenConfirm}
        setisOpenConfirm={setIsOpenConfirm}
        setIsPayOpen={setIsPayOpen}
        setTenderedUSD={setTenderedUSD}
        setTenderedLBP={setTenderedLBP}
        setReturnedUSD={setReturnedUSD}
        setReturnedLBP={setReturnedLBP}
        setOverpaymentUSD={setOverpaymentUSD}
      />
    </>
  );
};
export default Pay;
